import { Container, Typography, Box } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import ErrorAnimation from "../components/Lottie/ErrorAnimation";

export default function NotFound({ credentialErr = false }) {
  return (
    <Container maxWidth={false} sx={{ maxWidth: "425px" }}>
      <Header showBar={false} disabledBackBtn={true} showLogoutBtn={false} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <ErrorAnimation />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h2" color="primary" sx={{ mt: 1, mb: 2 }}>
            {credentialErr
              ? "Incorrect URL, please enter correct URL"
              : "Page NOT Found !!!"}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
